import * as React from "react";

function SvgMailjet(props, ref) {
  return (
    <svg
      id="Mailjet_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 416.7 436.3"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".Mailjet_svg__st1{fill:#fead0d}"}</style>
      <path
        className="Mailjet_svg__st1"
        d="M1.9 181l151.4 68.9 30.5-30.5-77.5-35.3 240.2-92.4-92.3 240.1-35-77.1-30.5 30.5 1.6 3.5 67 147.5L416.7 21.4 1.9 181z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgMailjet);
